import { useHistory, useRouteMatch } from 'react-router-dom';

export const useKybNavigation = () => {
  const history = useHistory();
  const { url } = useRouteMatch();
  const basePath = url.split('/business-verification')[0].concat('/business-verification');

  const navigate = (url: string) => {
    history.push(`${basePath}${url}`);
  };

  return {
    navigate,
  };
};
